<template>
    <div class="OptionsPage">
        <section class="fs14 co_ff8 commonBox">
            <div v-for="(item, index) in showData" :key="item + index" class="listCommon flex_box align-items_center"
                 @click="changeIndex(index, item)">
                <p class="checkBox" :class="{ active: activeIndex === index, disabled: (!token && !~selectIndex[selectType].indexOf(index) )}"><span class="point"></span></p>
                <span>{{ item.label }}</span>
            </div>
            <div v-if='showTimeBox' class="select flex_box align-items_center mt10" @click="selectMonth">
                <p class="flex_1 fs14 co_ff8 text_l">{{ showTime | formatMonth }}</p>
                <img src="../assets/img/icon/iconDown.svg" alt="下拉">
            </div>
        </section>
        <section class="footBtnCommon text_c fs18 font_b">
            <div class="footBtn co_fff bg_538DFF fs18" @click="confirm">确定</div>
        </section>
        <!--    时间选择器 & 不包含日期    -->
        <div v-show="showDateMouthBox" class="pickerPop pickMouthPop" @touchmove.prevent>
            <!-- 年月日时分选择 -->
            <mt-datetime-picker ref="dateMouthPicker"
                                lockScroll="true"
                                v-model="dateMouthVal"
                                :visible-item-count="5"
                                :endDate="endDate"
                                :startDate="startDate"
                                type="date"
                                :closeOnClickModal="false"
                                year-format="{value}"
                                month-format="{value}"
                                @cancel="showDateMouthBox = false"
                                @confirm="dateMouthConfirm()">
            </mt-datetime-picker>
            <!--            <p class="fixedTitle fs12 co_ff4">选择开始日期</p>-->
        </div>
    </div>
</template>

<script>
import co from "../util/const";
import _ from "loadsh";
import moment from "moment";
import utils from "@/util/common";
import Req from "@/util/request";

export default {
    name: "OptionsPage",
    data() {
        return {
            pageType: null,
            entity: null,
            showData: [],
            selectIndex:{
                timeList:[2],
                subIndustries:[0,1],
                industries:[1,2]
            },
            selectType: "",
            activeIndex: -1,
            showDateMouthBox: false,
            showTimeBox: false,
            showTime: moment().toDate(),
            dateMouthVal: moment().toDate(),
            endDate: moment().subtract(1, 'day').toDate(),
            startDate: moment().subtract(12, 'months').startOf('year').toDate(),
            token: utils.getCookie("xinhuaToken") || null,

        }
    },
    filters: {
        formatMonth(date) {
            if (!date)
                return '';
            return moment(date).format('YYYY/MM')
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        // disabledSelect(){
        //     let {custom} = this.$route.query;
        //     return
        // },
        async init() {
            this.pageType = this.$route.query.pageType;
            let {custom, entity} = this.$route.query;
            let isNotVip = localStorage.getItem('xinhuaUser') && JSON.parse(localStorage.getItem('xinhuaUser')).vipLevel < 1;
            if (custom) {
                co.timeList.splice(3, 1, {key: '自定义月份', label: '自定义月份'},)
            }

            let pageType = this.pageType;
            if (pageType.includes('subIndustries')) {
                pageType = 'subIndustries';
            } else if (pageType.includes('industries')) {
                pageType = 'industries';
            } else if (pageType.includes('companies')) {
                pageType = 'companies';
            } else if (pageType.includes('AllCompanies')) {
                pageType = 'AllCompanies';
            }
            if (~['subIndustries', 'industries'].indexOf(pageType)) {
                //普通用户只能到银行业和证劵业
                this.showData = isNotVip ? co.defaultIndustries : co[pageType];

            } else if (['companies', 'allCompanies'].includes(pageType)) {
                this.showData = await this.getCompareCompanies(JSON.parse(localStorage.getItem('xinhuaUser')));
            } else {
                this.showData = co[pageType]
            }

            if (entity){
                this.activeIndex = _.findIndex(this.showData, function (o) {
                    return o.label == entity;
                });
            }
            if(!this.token && pageType=="timeList"){
                this.activeIndex = 2;
            }
            this.selectType = pageType;
        },
        selectMonth() {
            this.dateMouthVal = this.showTime;
            this.$refs['dateMouthPicker'].open()
            this.showDateMouthBox = true;
        },
        // 时间选择器确定按钮
        dateMouthConfirm() { // 时间选择器确定按钮，并把时间转换成我们需要的时间格式
            this.showTime = this.dateMouthVal
            this.showDateMouthBox = false;
        },
        confirm() {
            if (this.activeIndex < 0) {
                this.$messagebox({
                    title: '',
                    message: '未选择内容，无法提交',
                });
                return
            }
            let data = this.showData[this.activeIndex].label;
            if (this.pageType === 'timeList') {
                data = JSON.stringify({
                    showText: data,
                    startDate: utils.getTimeName(data !== '自定义月份' ? data : this.showTime),
                    endDate: data === '自定义月份' ? Math.min(moment(this.showTime).endOf('month').valueOf(), moment().endOf('day').valueOf())
                        : moment().valueOf(),
                })
            }

            sessionStorage.setItem(this.pageType, data)

            this.$router.go(-1);
        },
        changeIndex(index, item) {
            if(!this.token && !~this.selectIndex[this.selectType].indexOf(index)){
                return ;
            }

            this.activeIndex = index;
            this.showTimeBox = false;
            if (item.label === '自定义月份') {
                this.showTimeBox = true;
            }
        },
        async getCompareCompanies(user) {
            if (!user)
                return [];

            let resp = await Req.userInfo()
            let myConcern = resp.user?.myConcern || [];
            let mySubscribes = resp.user?.mySubscribes || [];
            let list = _.map(mySubscribes.concat(myConcern), c => {
                return {
                    key: c.company,
                    label: c.company
                }
            });
            return _.uniqBy(list, 'key');

        }
    }
}
</script>

<style lang="scss" scoped>
.commonBox {
    padding: 16px;

    .listCommon {
        padding: 15px 0;
    }
}

.noClick {
    opacity: 0.6;
}

.select {
    width: 314px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #C9C9CA;
    padding: 0 16px 0 8px;
    margin-left: 28px;

    img {
        width: 16px;
    }
}

.mint-popup {
    background-color: #fff;
    width: 100%;

    .chooseBox {
        height: 55px;
        line-height: 55px;

        .cancel {
            margin: 0 143px 0 80px;
        }
    }

    .titleCom {
        padding: 16px;
    }
}

.pickerPop {
    width: 100%;
    height: 265px;
    position: fixed;
    bottom: 0;
    z-index: 10;

    .fixedTitle {
        position: absolute;
        top: 16px;
        left: 16px;
        z-index: 200000;
    }
}

.checkBox {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid #C9C9CA;
    padding: 0 3px;
    position: relative;
    margin-right: 8px;
    &.active {
        border: 1px solid #B1CCFF;

        .point {
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #538DFF;
            position: absolute;
            top: 3px;
            left: 3px;
        }
    }
    &.disabled {
        border: 1px solid #c2c5cb;

        .point {
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #c2c5cb;
            position: absolute;
            top: 3px;
            left: 3px;
        }
    }
}
</style>